import { render, staticRenderFns } from "./profile-other-docs.vue?vue&type=template&id=4b40f582&scoped=true&"
import script from "./profile-other-docs.vue?vue&type=script&lang=js&"
export * from "./profile-other-docs.vue?vue&type=script&lang=js&"
import style0 from "./profile-other-docs.vue?vue&type=style&index=0&id=4b40f582&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40f582",
  null
  
)

export default component.exports